// Copyright (c) 2017 Deere & Company

import * as fetchService from '../../../shared/services/fetch';
import {handleError} from '../../../shared/services/error-handlers';

const basePath = '/api';

export async function getNotifications() {

    const endPoint = `${basePath}/notifications`;
    const options = {
        cloudPreferred: true,
        endpointId: 'notifications'
    };

    try {

        const response = await fetchService.fetch(endPoint, options);

        return response.json();

    } catch (error) {

        return handleError(error);

    }

}

export async function getWip() {

    const endPoint = `${basePath}/wip`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (error) {

        return handleError(error);

    }

}

export async function getOpenPipSummary() {

    const endPoint = `${basePath}/open-pips-summary`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (error) {

        return handleError(error);

    }

}

export async function getTransferApprovalCount(selectedAccounts) {

    const endPoint = `${basePath}/wip`;

    const fetchOptions = {
        body: JSON.stringify(selectedAccounts),
        endpointId: 'transfers',
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, fetchOptions);

        return response.json();

    } catch (error) {

        return handleError(error);

    }

}



// WEBPACK FOOTER //
// ./src/home-page/shared/repositories/index.js